export default {
    yardi: 'Yardi',
    cardDesc: 'Smarter Property Management',
    cardSubDesc: 'Import resident data from Yardi. You will need property list code or property ID to enroll',
    propertyId: 'Property ID',
    properties: 'Properties',
    selectProperty: 'Select Property',
    commonWsdlLink: 'Common WSDL Link',
    username: 'Username',
    password: 'Password',
    serverName: 'Server Name',
    databaseName: 'Database Name',
    platform: 'Platform',
    enterYardiCredentials: 'Enter Yardi credentials to fetch the list of available properties',
    restBaseUrl: 'REST API URL',
    restBaseUrlPlaceholder: 'https://<client>.yardiconnects.com/sipp/api',
    restBaseUrlHttpsValidation: 'REST API URL must start with https://',
    restApiToken: 'API Token',
    applyRestCredentials: 'Apply REST Credentials',
    restMigrationTitle: 'Yardi REST API Migration',
    restMigrationHelp: 'Select connections below, then apply REST API credentials to migrate them.',
    restConfigured: 'REST Configured',
    restMigrationSuccess: 'Yardi REST credentials updated successfully.',
    restMigrationVisibilityWarning:
        'Credentials were saved, but some connections are not visible to this API token. Follow up with Yardi to grant access.',
    propertiesVisibleInRest: 'Properties visible in REST',
    restMigrationSkippedWarning: 'Some selected connections were skipped. Review the connection list and try again if needed.',
    testConnection: 'Test Connection',
    connectionSuccessful: 'Connection Successful. Please select the properties to connect to Swiftlane.',
    noPropertiesFound: 'No properties were found for these credentials. Check your credentials and try again.',
    useDifferentCredentials: 'Use different credentials',
    reauthoriseYardiConnection: 'Reauthorise Yardi Connection',
};
